import BigNumber from 'bignumber.js';
import { Address } from 'viem';

import { api } from 'modules/api';
import { getPublicClient } from 'modules/api/getPublicClient';
import { getLiquidUnstakePeriodDays } from 'modules/liquidStaking/methods/getLiquidUnstakePeriodDays';

interface IGetLiquidUnstakePeriodArgs {
  poolAddress?: Address;
}

export const { useGetLiquidUnstakePeriodQuery } = api.injectEndpoints({
  endpoints: build => ({
    getLiquidUnstakePeriod: build.query<
      BigNumber,
      IGetLiquidUnstakePeriodArgs | void
    >({
      queryFn: async params => {
        const client = getPublicClient();
        const { poolAddress } = params || {};

        const result = await getLiquidUnstakePeriodDays(client, poolAddress);

        return { data: result };
      },
      providesTags: [],
    }),
  }),
});
